import { useState } from 'react';
import { ExternalLink, Plus, Trash2, Link2 } from 'lucide-react';
import { format } from 'date-fns';
import { api } from '../../api/client';
import { CANAIS } from '../../lib/constants';
import { parseDate } from '../../lib/dates';

export function ResultadosSection({ demanda, onChange, podeEditar }) {
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState({ url: '', canal: '', label: '', publicado_em: '' });
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  const resultados = demanda.resultados || [];

  const add = async (e) => {
    e.preventDefault();
    if (!form.url) return;
    setSaving(true);
    setErr('');
    try {
      const r = await api.post(`/demandas/${demanda.codigo}/resultados`, {
        url: form.url,
        canal: form.canal || null,
        label: form.label || null,
        publicado_em: form.publicado_em || null,
      });
      onChange?.(r.resultados);
      setForm({ url: '', canal: '', label: '', publicado_em: '' });
      setAdding(false);
    } catch (e) {
      setErr(e.message);
    } finally {
      setSaving(false);
    }
  };

  const remove = async (itemId) => {
    if (!confirm('Remover este resultado?')) return;
    const r = await api.del(`/demandas/${demanda.codigo}/resultados/${itemId}`);
    onChange?.(r.resultados);
  };

  const labelCanal = (k) => CANAIS.find((c) => c.key === k)?.label || k;

  return (
    <div className="card">
      <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <strong>Resultados publicados</strong>
          <div className="text-xs muted">Links do que foi postado (reels, stories, notícias...)</div>
        </div>
        {podeEditar && !adding && (
          <button className="btn btn-secondary btn-sm" onClick={() => setAdding(true)}>
            <Plus size={14} /> Adicionar
          </button>
        )}
      </div>
      <div className="card-body">
        {adding && (
          <form onSubmit={add} className="stack" style={{ gap: 10, marginBottom: 14 }}>
            <input className="input" type="url" required placeholder="https://..." value={form.url} onChange={(e) => setForm((f) => ({ ...f, url: e.target.value }))} />
            <div className="grid-2" style={{ gap: 10 }}>
              <select className="select" value={form.canal} onChange={(e) => setForm((f) => ({ ...f, canal: e.target.value }))}>
                <option value="">Canal (opcional)</option>
                {CANAIS.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}
              </select>
              <input type="date" className="input" value={form.publicado_em} onChange={(e) => setForm((f) => ({ ...f, publicado_em: e.target.value }))} />
            </div>
            <input className="input" placeholder="Rótulo (ex: 'Reels do mutirão')" value={form.label} onChange={(e) => setForm((f) => ({ ...f, label: e.target.value }))} />
            {err && <div style={{ color: 'var(--c-danger)', fontSize: 13 }}>{err}</div>}
            <div className="row" style={{ justifyContent: 'flex-end', gap: 8 }}>
              <button type="button" className="btn btn-ghost btn-sm" onClick={() => setAdding(false)}>Cancelar</button>
              <button type="submit" className="btn btn-primary btn-sm" disabled={saving}>{saving ? 'Salvando...' : 'Adicionar'}</button>
            </div>
          </form>
        )}

        {resultados.length === 0 ? (
          <div className="text-sm muted">Nenhum resultado cadastrado ainda.</div>
        ) : (
          <div className="stack" style={{ gap: 8 }}>
            {resultados.map((r) => (
              <div key={r.id} style={{ display: 'flex', gap: 10, alignItems: 'center', padding: 10, border: '1px solid var(--c-border)', borderRadius: 10 }}>
                <Link2 size={16} style={{ color: 'var(--c-primary)', flexShrink: 0 }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                    {r.canal && <span className="badge info" style={{ fontSize: 10 }}>{labelCanal(r.canal)}</span>}
                    {r.label && <strong style={{ fontSize: 13 }}>{r.label}</strong>}
                    {r.publicado_em && <span className="text-xs muted">{format(parseDate(r.publicado_em), 'dd/MM/yyyy')}</span>}
                  </div>
                  <a href={r.url} target="_blank" rel="noreferrer" style={{ color: 'var(--c-primary)', fontSize: 12, wordBreak: 'break-all', display: 'inline-block', marginTop: 2 }}>
                    {r.url}
                  </a>
                </div>
                <a href={r.url} target="_blank" rel="noreferrer" className="btn btn-ghost btn-icon btn-sm" title="Abrir">
                  <ExternalLink size={14} />
                </a>
                {podeEditar && (
                  <button className="btn btn-ghost btn-icon btn-sm" onClick={() => remove(r.id)} title="Remover">
                    <Trash2 size={14} style={{ color: 'var(--c-danger)' }} />
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
